import { render, staticRenderFns } from "./RoomsMatchesArea.vue?vue&type=template&id=28995d1c&scoped=true"
import script from "./RoomsMatchesArea.vue?vue&type=script&lang=js"
export * from "./RoomsMatchesArea.vue?vue&type=script&lang=js"
import style0 from "./RoomsMatchesArea.vue?vue&type=style&index=0&id=28995d1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28995d1c",
  null
  
)

export default component.exports